// extracted by css-extract-rspack-plugin
export default {"systemMessageAlert":"systemMessageAlert-txle9b","alert":"alert-M0MD9L"};